import React from 'react';
import Paragraph from '../paragraph';
import IconButton from '../icon-button';
import ColorCircle from '../color-circle';
import Tag from '../tag';
import HorizontalStack from '../horizontal-stack';

// @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
function ColorItem({
  resetTooltipLabel = '',
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onResetClick = null,
  onEditClick,
  title,
  color,
  tagLabel = '',
  opacity = 1,
}) {
  const handleResetClick = (e) => {
    e.stopPropagation();
    onResetClick();
  };

  return (
    <div className="ws-ui-color-item" onClick={onEditClick}>
      <div className="ws-ui-color-item__container">
        <Paragraph isClipped>{title}</Paragraph>
        {tagLabel && <Tag label={tagLabel} size="small" appearance="cta-secondary" />}
      </div>
      <HorizontalStack verticalAlign="center" align="right" gap="spacing-2-xs">
        {/* @ts-ignore TS(2774): This condition will always return true since this ... Remove this comment to see the full error message */}
        {onResetClick && (
          <div className="ws-ui-color-item__icon-button">
            <IconButton
              glyph="reset"
              appearance="light"
              size="medium"
              // @ts-ignore TS(2322): Type 'string' is not assignable to type 'null | un... Remove this comment to see the full error message
              label={resetTooltipLabel}
              // @ts-ignore TS(2322): Type 'true' is not assignable to type 'null | unde... Remove this comment to see the full error message
              transparent
              // @ts-ignore TS(2322): Type '(e: any) => void' is not assignable to type ... Remove this comment to see the full error message
              onClick={handleResetClick}
            />
          </div>
        )}
        <ColorCircle color={color} opacity={opacity} size="medium" />
      </HorizontalStack>
    </div>
  );
}

export default ColorItem;
